module.exports = __webpack_public_path__ + "img/R03_04.95f23beb.svg";